<div>
  <form [formGroup]="_customForm" (ngSubmit)="_customFormSubmit()" class="p-10">
    <div class="row">
      <div class="mandatory-options">
        <span class="mandatory_sign_checklist">*</span>
        <span class="color-netral-700 font-size-14 inter-regular">{{"common_text.mandetory_text" |
          translate}}</span>
      </div>
      <ng-container *ngFor="let zone of customFormJson;trackBy: trackByTemplateId;let i = index">
        <span>
          <div class="col-12" id="Zone_{{i}}" *ngIf="zone?.templateQues && zone?.templateQues.length > 0">
            <h6 class="Zone_{{i}} font-size-16 color-netral-600">{{i+1}} {{zone.templateName}}</h6>
          </div>
          <div class="col-12" *ngFor="let formData of zone.templateQues;trackBy: trackByControlName;let j = index"
            [ngSwitch]="true">
            <div class="row" *ngIf="isVisible(formData)">
              <!-- <h4 [id]="formData.controlName"
                *ngIf="formData.controlType == 'label' && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label11 inter-regular m-5-0-0-0 font-size-18 color-netral-900">
                {{formData.label[_appSetting.selectedLanguage]}}
              </h4> -->
              <h6 [id]="formData.controlName"
                *ngIf="formData.controlType == 'catheading' && formData.dependentControlDetail.isDependent==false "
                class="{{formData.layoutClass}} col-form-label11 inter-regular m-5-0-0-0 font-size-18 color-netral-900">
                <b>{{formData.label[_appSetting.selectedLanguage]}}
                </b>
              </h6>
              <h6 [id]="formData.controlName" style="padding-left:15px"
                *ngIf="formData.controlType == 'catsubheading' && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label11 inter-regular m-5-0-0-0 font-size-18 color-netral-900">
                {{formData.label[_appSetting.selectedLanguage]}}
              </h6>
              <!-- [hidden]="formData?.isEnable == false" -->
              <label
                *ngIf="isHeading(formData) && formData.dependentControlDetail.isDependent==false && formData.controlType != 'third_party_trigger'"
                class="{{formData.layoutClass}} col-form-label color-netral-900 inter-regular font-size-15"
                for="{{formData.controlName}}" [hidden]="formData?.isEnable == false">
                {{formData.label[_appSetting.selectedLanguage]}}<span class="error" *ngIf="formData.isRequired"
                  style="font-size: 16px;padding: 5px;">*</span>
              </label>
              <!-- [hidden]="formData?.isEnable == false" -->
              <div *ngIf="isHeading(formData)" class="{{formData.layoutClass}}">
                <ng-container *ngIf="formData.dependentControlDetail.isDependent==false">
                  <div class="input-with-go">
                    <input type="{{formData.controlType}}" [hidden]="formData?.isEnable == false"
                      name="{{formData.controlName}}" class="form-control datepickerfix"
                      [ngClass]="{'form-control-error': _tempDynamicStoreconfig.highlightcontrols}" *ngSwitchDefault
                      [formControlName]="formData.controlName"
                      (change)="onInputChange(formData,i,zone.templateName,zone.templateId)"
                      placeholder="{{formData.placeholder}}">
                  </div>
                </ng-container>
                <div *ngSwitchCase="formData.controlType == 'third_party_trigger'"
                  class="d-flex justify-content-between align-items-center fetch-attom-control" [ngClass]="{
                  'fetch-attom-default': formData.status === 'default',
                  'fetch-attom-error': formData.status === 'error',
                  'fetch-attom-success': formData.status === 'success',
                  'fetch-attom-loading': formData.status === 'loading'
                }">
                  <span class="attom-label inter-regular">{{ formData.label[_appSetting.selectedLanguage] }}</span>
                  <!-- Icon button -->
                  <ng-container [ngSwitch]="formData.status">
                    <!-- Default -->
                    <button *ngSwitchCase="'default'" type="button" class="btn btn-link p-0"
                      (click)="onGoClick(formData,zone.templateId)">
                      <ion-icon name="arrow-forward-circle-outline" size="large" color="primary"></ion-icon>
                    </button>
                    <!-- Loading -->
                    <div *ngSwitchCase="'loading'">
                      <ion-spinner name="crescent" color="primary"></ion-spinner>
                    </div>

                    <!-- Error (retry) -->
                    <button *ngSwitchCase="'error'" type="button" class="btn btn-link p-0"
                      (click)="onGoClick(formData,zone.templateId)">
                      <ion-icon name="refresh-circle-outline" size="large" color="danger"></ion-icon>
                    </button>

                    <!-- Success -->
                    <div *ngSwitchCase="'success'">
                      <ion-icon name="checkmark-circle-outline" size="large" color="success"></ion-icon>
                    </div>
                  </ng-container>
                </div>


                <!-- AI REPORT SUMMARY -->
                <div *ngSwitchCase="formData.controlType == 'ai_report_summary'"
                  class="d-flex justify-content-between align-items-center fetch-attom-control">
                  <span class="attom-label inter-regular">{{ formData.label[_appSetting.selectedLanguage] }}</span>
                  <!-- Icon button -->
                  <ng-container [ngSwitch]="formData.status">
                    <!-- Default -->
                    <button *ngSwitchCase="'default'" type="button" class="btn btn-link p-0"
                      (click)="generateReportSummary(formData,zone.templateId)">
                      <ion-icon name="arrow-forward-circle-outline" size="large" color="primary"></ion-icon>
                    </button>
                    <div *ngSwitchCase="'loading'">
                      <ion-spinner name="crescent" color="primary"></ion-spinner>
                    </div>
                  </ng-container>
                </div>

                <button fill="clear" type="button" *ngSwitchCase="formData.controlType === 'link'"
                  class="open-file-btn float-left" (click)="openPreInspectionReport(formData)">
                  {{'self_pwa_text.click_here_btn' | translate}}
                </button>
                <!-- (click)="goToCustomTextArea(formData,i,zone.templateName,zone.templateId)" -->
                <!--   -->
                <textarea name="{{formData.controlName}}" class="form-control" rows="4"
                  [ngClass]="{'form-control-error': _tempDynamicStoreconfig.highlightcontrols}"
                  [formControlName]="formData.controlName" placeholder="{{formData.placeholder}}"
                  (change)="onInputChange(formData,i,zone.templateName,zone.templateId)" (input)="autoResize($event)"
                  *ngSwitchCase="formData.controlType === 'textarea'&& formData.dependentControlDetail.isDependent==false"></textarea>
                <select [id]="formData.controlName" autocomplete="on"
                  *ngSwitchCase="formData.controlType == 'select' && formData.dependentControlDetail.isDependent==false"
                  class="form-control" [ngClass]="{'form-control-error': _tempDynamicStoreconfig.highlightcontrols}"
                  [formControlName]="formData.controlName"
                  (change)="filterVal(formData,i,zone.templateName,zone.templateId)">
                  <option value=''>{{"common_text.select_text" | translate}}</option>
                  <ng-container *ngFor="let opt of formData.controlOptions">
                    <ng-container *ngIf="formData.dependentControlDetail.isDependent;else notdependent;">
                      <option *ngIf="opt.filterValue == formData.dependentControlDetail.dependentValue"
                        [value]="opt.id">
                        {{opt.option[_appSetting.selectedLanguage]}}</option>
                    </ng-container><ng-template #notdependent>
                      <option [value]="opt.id">{{opt.option[_appSetting.selectedLanguage]}}</option>
                    </ng-template>
                  </ng-container>
                </select>


                <div class="custom-control custom-switch"
                  *ngSwitchCase="formData.controlType == 'radio' && formData.dependentControlDetail.isDependent==false">
                  <div class="form-check form-check-inline" *ngFor="let item of formData.controlOptions">
                    <input class="form-check-input" [formControlName]="formData.controlName" type="radio"
                      value="{{item.id}}" (change)="conditionChange(formData,i,zone.templateName,zone.templateId)">
                    <label
                      class="form-check-label font-size-15 color-netral-600">{{item.option[_appSetting.selectedLanguage]}}</label>
                  </div>
                </div>

                <div class="custom-control custom-switch" style="line-height: 2.5;"
                  *ngSwitchCase="formData.controlType === 'workflow'&& !formData.dependentControlDetail.isDependent">
                  <div class="form-check form-check-inline" *ngFor="let item of formData.controlOptions">
                    <input class="form-check-input"
                      (change)="conditionChange(formData,i,zone.templateName,zone.templateId)"
                      [formControlName]="formData.controlName" type="radio" [value]="item.id">
                    <label class="form-check-label">{{item.option[_appSetting.selectedLanguage]}}
                      <span><ion-icon name="information-circle-outline"
                          (click)="toggleTooltip(item.description[_appSetting.selectedLanguage])"></ion-icon></span>
                    </label>
                  </div>
                </div>

                <!--   -->
                <!-- [checked]="(formData.controlvalue).includes(item.id)" -->
                <div class="custom-control l-h-2-5"
                  *ngSwitchCase="formData.controlType === 'checkbox' && formData.dependentControlDetail.isDependent==false">
                  <div class="form-check form-check-inline main-area-checkbox checkboxstyle"
                    *ngFor="let item of formData.controlOptions; let i=index">
                    <input class="form-check-input checkboxdesign" [checked]="(formData.controlvalue).includes(item.id)"
                      type="checkbox" [value]="item.id"
                      (change)="onCheckChange($event,item,formData.controlName,formData,zone.templateName,zone.templateId)">
                    <label
                      class="form-check-label font-size-15 color-netral-600">{{item.option[_appSetting.selectedLanguage]}}
                    </label>
                  </div>
                </div>
                <div
                  *ngSwitchCase="formData.controlType == 'files' && formData.dependentControlDetail.isDependent==false">
                  <div class="w-100" *ngIf="formData.controlvalue == '' ">
                    <input type="file" accept=".pdf,.doc,.docx" class="float-left" [id]="formData.controlName">
                    <button type="button" class="btn btn-primary float-right" (click)="fileCapture(formData)">
                      <i class="bi bi-upload"></i>
                    </button>
                  </div>
                  <div *ngIf="formData.controlvalue != ''" class="ion-text-center w-100">
                    <span *ngFor="let item of formData.controlvalue" style="display: flex;">
                      <span [title]="formData.controlvalue[0].fileName">{{
                        (formData.controlvalue[0].fileName.length>20)? (formData.controlvalue[0].fileName |
                        slice:0:20)+'..':(formData.controlvalue[0].fileName) }}</span>
                      <div style="    position: absolute;right: 0;">
                        <ion-icon *ngIf="fileList?.length > 0" class="downloadicon" name="cloud-download-outline"
                          (click)="documentMapFile(item)"></ion-icon>
                        <ion-icon name="trash-outline" class="deleteicon"></ion-icon>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="error" *ngSwitchCase="formData.controlType == 'checkbox'  && formData.isRequired">
                  <div class="error-txt-msg mb-2 m-l-10"
                    *ngIf="_customForm?.controls[formData.controlName].value.length == 0">
                    <!-- {{formData.label[_appSetting.selectedLanguage]}} {{"native_text.required_text" | translate}} -->
                    {{'self_pwa_text.checklist_validation_message' | translate}}
                  </div>
                </div>
                <div class="error"
                  *ngIf="_tempDynamicStoreconfig.highlightcontrols && (_customForm?.controls[formData.controlName].dirty || _customForm?.controls[formData.controlName].touched)">
                  <div class="error-txt-msg mb-2 m-l-10"
                    *ngIf="_customForm.controls[formData.controlName].hasError('required')">
                    {{'self_pwa_text.checklist_validation_message' | translate}}
                  </div>
                  <div class="error-txt-msg mb-2 m-l-10"
                    *ngIf="_customForm?.controls[formData.controlName].hasError('pattern')">
                    {{"native_text.format_incorrect_text" | translate}}
                  </div>
                </div>
                <div class="col-12 responseLayout " style="margin-left: 8px;"
                  *ngSwitchCase="formData.controlType == 'table'">
                  <div class="aadbtn" *ngIf="formData.isRepeat==true">
                    <table>
                      <thead>
                        <tr>
                          <h6 class="addrow" (click)="addnewrow(formData,formData.tableData.value,zone,i)">ADD ROW
                          </h6>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="tableviewscroll">
                    <table class="tablecontrol" style="border-collapse: collapse;
                    display: block;
                    overflow-x: auto;
                    white-space: nowrap;">
                      <thead>
                        <tr>
                          <th *ngIf="formData.isRepeat==true"></th>
                          <th class="tablehead" *ngFor="let list of formData.tableData.head">
                            {{list[_appSetting.selectedLanguage]}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let val of formData.tableData.value;let i=index;let isLast=last;let isFirst=first">
                          <td class="tdwidth" *ngIf="formData.isRepeat==true">
                            <span class="text-center">
                              <ion-icon class="deleteicon" *ngIf="formData.tableData.value.length !=1"
                                name="trash-outline" (click)="removeRow(i,formData.tableData.value)"></ion-icon>
                              &nbsp;
                            </span>
                          </td>

                          <td class="tabledata" *ngFor="let d of val[i+1]"
                            (click)="getTableData(val,i,formData,zone.templateName,zone.templateId)">
                            <span class="form-control innerlabel setbackground"
                              *ngSwitchCase="d.controlType === 'label'">{{d.label[_appSetting.selectedLanguage]}}</span>
                            <input readonly="true" class="form-control setbackground" type="{{d.controlType}}"
                              name="controlvalue" value="{{d.controlvalue}}" (change)="setTableCtlVal($event.target,d)"
                              *ngSwitchCase="d.controlType == 'textbox'" placeholder="{{d.placeholder}}">
                            <textarea readonly="true" class="form-control setbackground" name="controlvalue"
                              placeholder="{{d.placeholder}}" *ngSwitchCase="d.controlType === 'textarea'"
                              (change)="setTableCtlVal($event.target,d)">
                                    </textarea>
                            <select autocomplete="on" readonly="true" *ngSwitchCase="d.controlType === 'select'"
                              class="form-control setbackground" (change)="setTableCtlVal($event.target,d)"
                              name="controlvalue">
                              <option value=''><u>Select an Option</u></option>
                              <option *ngFor="let opt of d.controlOptions" [value]="opt.id"
                                [selected]="opt.id === d.controlvalue">
                                {{opt.option[_appSetting.selectedLanguage]}}
                              </option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </ng-container>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <ion-button expand="block" [hidden]='hiddenSubmitButton' *ngIf="formFieldsJson?.length > 0" type="submit"
          class="t-c commonbtn show-fulltext h-48 font-size-15 inter-medium">
          {{"common_btn_text.save_btn" | translate}}
        </ion-button>
      </div>
      <div class="custom-tooltip" *ngIf="isTooltipVisible">
        {{description}}
      </div>
    </div>
  </form>
</div>